import { Volume2, VolumeX } from "lucide-react";
import { AiBadge } from "@/components/Badges";

export default function MixerStrip({ track, state, onChange, playing, confidence }) {
  const { volume = 1, muted = false, solo = false } = state || {};

  const vuBars = 12;
  const active = playing && !muted;
  const level = active ? volume : 0;

  return (
    <div
      data-testid={`mixer-strip-${track.key}`}
      className="flex items-center gap-3 rounded-xl border border-[#222A38] bg-[#11151D] p-3"
    >
      <span className="h-10 w-1.5 shrink-0 rounded-full" style={{ backgroundColor: track.color }} />
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1.5">
          <span className="truncate text-sm font-semibold text-white">{track.label}</span>
          {track.ai && <AiBadge />}
          {confidence != null && (
            <span className="font-mono-sw text-[10px] text-slate-500">{Math.round(confidence * 100)}%</span>
          )}
        </div>
        <div className="mt-2 flex items-center gap-2">
          <div className="sw-slider-track flex-1">
            <input
              data-testid={`fader-${track.key}`}
              type="range" min="0" max="1" step="0.01" value={volume}
              onChange={(e) => onChange({ ...state, volume: parseFloat(e.target.value) })}
              className="w-full"
            />
          </div>
          {/* VU meter */}
          <div className="hidden items-end gap-0.5 sm:flex" style={{ height: 20 }}>
            {Array.from({ length: vuBars }).map((_, i) => {
              const on = level * vuBars > i;
              const color = i > 9 ? "#EF4444" : i > 6 ? "#F59E0B" : "#10B981";
              return (
                <span
                  key={`vu-${track.key}-${i}`}
                  className="w-1 rounded-sm transition-all duration-150"
                  style={{
                    height: `${6 + i * 1.2}px`,
                    backgroundColor: on ? color : "#222A38",
                    opacity: on ? (active ? 0.6 + Math.random() * 0.4 : 1) : 0.5,
                  }}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex shrink-0 flex-col gap-1.5">
        <button
          data-testid={`mute-${track.key}`}
          onClick={() => onChange({ ...state, muted: !muted })}
          className={`flex h-7 w-7 items-center justify-center rounded-md text-xs font-bold transition-colors ${
            muted ? "bg-red-500/20 text-red-400" : "bg-[#1A202C] text-slate-400 hover:text-white"
          }`}
          title="Mute"
        >
          {muted ? <VolumeX size={14} /> : <Volume2 size={14} />}
        </button>
        <button
          data-testid={`solo-${track.key}`}
          onClick={() => onChange({ ...state, solo: !solo })}
          className={`flex h-7 w-7 items-center justify-center rounded-md text-[11px] font-bold transition-colors ${
            solo ? "bg-cyan-500/20 text-cyan-300" : "bg-[#1A202C] text-slate-400 hover:text-white"
          }`}
          title="Solo"
        >
          S
        </button>
      </div>
    </div>
  );
}
